import React, { useEffect, useState, useMemo } from "react";
import Select from "react-select";
import { GetServiceCaller } from "../../../../../services/serviceCaller";
import { API_URL } from "../../../../../constants";
import { Table, Form, Dropdown } from "react-bootstrap";
import moment from "moment";
import Pagination from "../../../../../components/Pagination";
import SearchBar from "../../../../../components/SearchBar";
import ExportToExcel from "../../../../../components/ExportToExcel";
import { Accordion, Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus, faColumns } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../../constants/layout/store/filterSlice";
import { FaSpinner } from "react-icons/fa";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Dynamic_FilterForm from "../../../../../components/Dynamic_FilterForm";

const MyResource = (data) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("My Resource"));
  }, []);

  const [resource, setResource] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [clientListData, setClientListData] = useState([]);
  const [projectListData, setProjectListData] = useState([]);
  const [employeeListData, setEmployeeListData] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);

  // Column configuration with consistent widths
  const [columnVisibility, setColumnVisibility] = useState({
    employeeName: true,
    fromDate: true,
    toDate: true,
    role: true,
    billingRate: true,
    action: true,
  });

  // Define column styles
  const columnStyles = {
    base: {
      minWidth: "120px",
      maxWidth: "200px",
      textAlign: "left",
      padding: "8px 12px",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    employeeName: { width: "200px", minWidth: "200px" },
    dates: { width: "120px", minWidth: "120px", textAlign: "center" },
    role: { width: "150px", minWidth: "150px" },
    billingRate: { width: "120px", minWidth: "120px", textAlign: "right" },
    action: { width: "100px", minWidth: "100px", textAlign: "center" },
    serial: { width: "60px", minWidth: "60px", textAlign: "center" },
  };

  const columns = [
    {
      id: "employeeName",
      label: "Resource Name",
      accessor: "EmployeeName",
      style: columnStyles.employeeName,
    },
    {
      id: "fromDate",
      label: "From ",
      accessor: "FromDate",
      format: (val) => (val ? moment(val).format("DD-MMM-YYYY") : null),
      style: columnStyles.dates,
    },
    {
      id: "toDate",
      label: "To ",
      accessor: "ToDate",
      format: (val) => (val ? moment(val).format("DD-MMM-YYYY") : null),
      style: columnStyles.dates,
    },
    {
      id: "role",
      label: "Role",
      accessor: "Role",
      style: columnStyles.role,
    },
    {
      id: "billingRate",
      label: "Billing Rate",
      accessor: "InvoiceRate",
      style: columnStyles.billingRate,
    },
    {
      id: "action",
      label: "Action",
      accessor: "",
      style: columnStyles.action,
    },
  ];

  const toggleColumnVisibility = (columnId) => {
    setColumnVisibility((prev) => ({
      ...prev,
      [columnId]: !prev[columnId],
    }));
  };

  useEffect(() => {
    fetchResourceReport();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const fetchResourceReport = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/reports/3?P_ProjectID=${""}&P_ClientID=${""}&P_EmployeeID=${""}`
      );
      setResource(response?.data?.data || []);

      // Process client, project, and employee lists
      setClientListData(
        response?.data?.clientlist?.map((item) => ({
          value: item.value,
          label: item.text,
        })) || []
      );

      setProjectListData(
        response?.data?.projectlist?.map((item) => ({
          value: item.value,
          label: item.text,
        })) || []
      );

      setEmployeeListData(
        response?.data?.employee?.map((item) => ({
          value: item.value,
          label: item.text,
        })) || []
      );
    } catch (error) {
      console.error("Error fetching resource report:", error);
    }
  };

  const fetchData = async () => {
    try {
      await GetServiceCaller(`${API_URL}resourceallocation-getdata`);
      setPageLoading(false);
    } catch (error) {
      console.error("Error fetching Resource Allocation:", error);
      setPageLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Filter data based on search term
  const filteredData = useMemo(() => {
    return resource.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [resource, searchTerm]);

  // Pagination logic
  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const getCurrentItems = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
    return filteredData.slice(startIndex, endIndex);
  };

  const currentItems = getCurrentItems();

  // Create nested structure for display
  const nestedData = useMemo(() => {
    return currentItems.reduce((acc, item) => {
      if (!acc[item.ClientName]) acc[item.ClientName] = {};
      if (!acc[item.ClientName][item.ProjectName]) {
        acc[item.ClientName][item.ProjectName] = [];
      }
      acc[item.ClientName][item.ProjectName].push(item);
      return acc;
    }, {});
  }, [currentItems]);

  const [activeClientKey, setActiveClientKeys] = useState([]);
  const [activeProjectKey, setActiveProjectKeys] = useState({});
  const [isInitialized, setIsInitialized] = useState(false);
const [loading,setLoading] = useState(false)
  
 useEffect(() => {
    if (!loading && Object.keys(nestedData).length > 0 && !isInitialized) {
      const allClientKeys = Object.keys(nestedData).map((_, i) => i.toString());
      setActiveClientKeys(allClientKeys);

      const allProjectKeys = {};
      Object.entries(nestedData).forEach(([_, projects], clientIndex) => {
        allProjectKeys[clientIndex.toString()] = Object.keys(projects).map((_, i) => i.toString());
      });

      setActiveProjectKeys(allProjectKeys);
      setIsInitialized(true);
    }
  }, [nestedData, loading, isInitialized]);
  // Accordion handlers
  const handleClientToggle = (clientIndex) => {
    setActiveClientKeys((prev) =>
      prev.includes(clientIndex)
        ? prev.filter((key) => key !== clientIndex)
        : [...prev, clientIndex]
    );
  };


  const handleProjectToggle = (clientIndex, projectKey) => {
    setActiveProjectKeys((prev) => {
      const openProjects = prev[clientIndex] || [];
      const isOpen = openProjects.includes(projectKey);

      return {
        ...prev,
        [clientIndex]: isOpen
          ? openProjects.filter((k) => k !== projectKey)
          : [...openProjects, projectKey],
      };
    });
  };

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;

    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage);
    setItemsPerPage(newRecordsPerPage);
  };

  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: filteredData.length, label: "All" },
  ];

  const formDatas = [
    { name: "Client", type: "Select", options: [...clientListData] },
    { name: "Project", type: "Select", options: [...projectListData] },
    { name: "Employee", type: "Select", options: [...employeeListData] },
  ];

  const [filterFormData, setFilterData] = useState([]);

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      if (existingLabelIndex !== -1) {
        return prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
      } else {
        return [
          ...prevFormData,
          { label: name, value: e.value !== undefined ? e.value : e },
        ];
      }
    });
  };

  const handleGetData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/reports/3?P_ProjectID=${
          filterFormData.find((o) => o.label === "Project")?.value || 0
        }&P_ClientID=${
          filterFormData.find((o) => o.label === "Client")?.value || 0
        }&P_EmployeeID=${
          filterFormData.find((o) => o.label === "Employee")?.value || 0
        }`
      );
      setResource(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching resource report:", error);
    }
  };

  const handleReset = () => {
    setFilterData([]);
    fetchResourceReport();
  };

  if (pageLoading) {
    return (
      <div className="position-absolute top-50 start-50 translate-middle text-center">
        <FaSpinner className="spinner" />
      </div>
    );
  }

  return (
    <div className="container-fluid" id="skill_section">
      <div className="container-fluid" id="skill-table-area">
        <div>
          <div className="mb-3">
            {/* Mobile layout (stacked in two rows) */}
            <div className="d-flex d-md-none flex-column">
              {/* First row - Search and Filter */}
              <div className="d-flex">
                <div className="me-1 flex-grow-1 mb-0">
                  <SearchBar
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
                <div className="dropdown">
                  <OverlayTrigger
                    placement="right"
                    overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
                  >
                    <button
                      className="dropdown-toggle"
                      type="button"
                      id="excel-btn"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="bi bi-funnel-fill"></i>
                    </button>
                  </OverlayTrigger>
                  <div>
                    <Dynamic_FilterForm
                      formData={formDatas || []}
                      handleChange={handleChange}
                      handleReset={handleReset}
                      handleGetData={handleGetData}
                      filterFormData={filterFormData}
                    />
                  </div>
                </div>
              </div>

              {/* Second row - Export and Column Chooser */}
              <div className="d-flex justify-content-end">
                <div className="me-1">
                  <ExportToExcel
                    data={resource}
                    filename="ResourceReport.csv"
                  />
                </div>
                <div>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Column Chooser</Tooltip>}
                  >
                    <div className="btn-group">
                      <button
                        type="button"
                        className="dropdown-toggle skill-button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        id="excel-btn"
                      >
                        <i className="bi bi-list"></i>
                      </button>
                      <ul className="dropdown-menu p-2">
                        <div className="row">
                          <Form.Group>
                            {columns.map((column) => (
                              <Form.Check
                                key={column.id}
                                type="checkbox"
                                id={`checkbox-${column.id}`}
                                label={column.label}
                                checked={columnVisibility[column.id]}
                                onChange={() =>
                                  toggleColumnVisibility(column.id)
                                }
                              />
                            ))}
                          </Form.Group>
                        </div>
                      </ul>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>

            {/* Desktop layout (original) - hidden on mobile */}
            <div className="d-none d-md-flex justify-content-between">
              <div className="d-flex">
                <div className="me-1">
                  <SearchBar
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
                <div className="dropdown">
                  <OverlayTrigger
                    placement="right"
                    overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
                  >
                    <button
                      className="dropdown-toggle"
                      type="button"
                      id="excel-btn"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="bi bi-funnel-fill"></i>
                    </button>
                  </OverlayTrigger>
                  <div>
                    <Dynamic_FilterForm
                      formData={formDatas || []}
                      handleChange={handleChange}
                      handleReset={handleReset}
                      handleGetData={handleGetData}
                      filterFormData={filterFormData}
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-end">
                <div className="me-1">
                  <ExportToExcel
                    data={resource}
                    filename="ResourceReport.csv"
                  />
                </div>
                <div className="me-1">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="tooltip-top">Column Chooser</Tooltip>}
                  >
                    <div className="btn-group me-2">
                      <button
                        type="button"
                        className="dropdown-toggle skill-button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        id="excel-btn"
                      >
                        <i className="bi bi-list"></i>
                      </button>
                      <ul className="dropdown-menu p-2">
                        <div className="row">
                          <Form.Group>
                            {columns.map((column) => (
                              <Form.Check
                                key={column.id}
                                type="checkbox"
                                id={`checkbox-${column.id}`}
                                label={column.label}
                                checked={columnVisibility[column.id]}
                                onChange={() =>
                                  toggleColumnVisibility(column.id)
                                }
                              />
                            ))}
                          </Form.Group>
                        </div>
                      </ul>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <Table bordered hover className="mb-3">
              <thead id="thcolor" className="text-center">
                <tr>
                  <th
                    style={{
                      ...columnStyles.serial,
                      width: columnStyles.serial.width,
                    }}
                  >
                    ##
                  </th>
                  {columns.map(
                    (column) =>
                      columnVisibility[column.id] && (
                        <th
                          key={column.id}
                          className="text-center"
                          style={{
                            ...column.style,
                            width: column.style.width, // Explicitly set width
                          }}
                        >
                          {column.label}
                        </th>
                      )
                  )}
                </tr>
              </thead>
              <tbody>
                {Object.keys(nestedData).length === 0 ? (
                  <tr>
                    <td
                      colSpan={
                        Object.values(columnVisibility).filter(Boolean).length +
                        1
                      }
                      className="text-center text-muted py-3"
                    >
                      No Record Found
                    </td>
                  </tr>
                ) : (
                  Object.entries(nestedData).map(
                    ([clientName, projects], clientIndex) => (
                      <tr key={clientIndex}>
                        <td
                          colSpan={
                            Object.values(columnVisibility).filter(Boolean)
                              .length + 1
                          }
                          className="px-0"
                          style={{ padding: "0px" }}
                        >
                          <Accordion
                            activeKey={activeClientKey}
                            onSelect={() =>
                              handleClientToggle(clientIndex.toString())
                            }
                          >
                            <Accordion.Item eventKey={clientIndex.toString()}>
                              <Accordion.Header className="AccordioninvoiceClient_header">
                                <span className="me-2 accordion_icon">
                                  <FontAwesomeIcon
                                    icon={
                                      activeClientKey === clientIndex.toString()
                                        ? faMinus
                                        : faPlus
                                    }
                                  />
                                </span>
                                <div className="flex-grow-1 text-dark fw-bold">
                                  {clientName}
                                </div>
                              </Accordion.Header>
                              <Accordion.Body className="p-0">
                                <Accordion
                                  activeKey={
                                    activeProjectKey[clientIndex] || null
                                  }
                                  onSelect={(projectKey) =>
                                    handleProjectToggle(clientIndex, projectKey)
                                  }
                                >
                                  {Object.entries(projects).map(
                                    ([projectName, items], projectIndex) => (
                                      <Accordion.Item
                                        eventKey={projectIndex.toString()}
                                        key={projectIndex}
                                      >
                                        <Accordion.Header>
                                          <div className="flex-grow-1 px-3 text-dark">
                                            {projectName}
                                            <span className="text-muted">
                                              {" "}
                                              (SOW/PO/SO{" "}
                                              {items[0]
                                                ?.ProjectInvoiceDetailNumber ||
                                                "N/A"}
                                              )
                                            </span>
                                          </div>
                                          <span className="me-2 accordion_icon">
                                            <FontAwesomeIcon
                                              icon={
                                                activeProjectKey[
                                                  clientIndex
                                                ] === projectIndex.toString()
                                                  ? faMinus
                                                  : faPlus
                                              }
                                            />
                                          </span>
                                        </Accordion.Header>
                                        <Accordion.Body className="p-0">
                                          <Table bordered hover>
                                            <tbody>
                                              {items.map((data, subIndex) => (
                                                <tr key={subIndex}>
                                                  <td
                                                    style={{
                                                      ...columnStyles.serial,
                                                      width:
                                                        columnStyles.serial
                                                          .width,
                                                    }}
                                                  >
                                                    {subIndex + 1}
                                                  </td>
                                                  {columns.map(
                                                    (column) =>
                                                      columnVisibility[
                                                        column.id
                                                      ] && (
                                                        <td
                                                          key={column.id}
                                                          style={{
                                                            ...column.style,
                                                            width:
                                                              column.style
                                                                .width, // Explicitly set width
                                                          }}
                                                        >
                                                          {column.format
                                                            ? column.format(
                                                                data[
                                                                  column
                                                                    .accessor
                                                                ]
                                                              )
                                                            : data[
                                                                column.accessor
                                                              ] || ""}
                                                        </td>
                                                      )
                                                  )}
                                                </tr>
                                              ))}
                                            </tbody>
                                          </Table>
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    )
                                  )}
                                </Accordion>
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </td>
                      </tr>
                    )
                  )
                )}
              </tbody>
            </Table>
          </div>
          <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-sm-between mb-3">
            {/* Text and per-page dropdown on the left */}
            <div className="d-flex justify-content-between px-2">
              <span
                className="d-flex align-items-center"
                style={{ width: "150px" }}
              >
                Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
                {Math.min(
                  currentPage * selectedRecordsPerPage,
                  filteredData.length
                )}{" "}
                of {filteredData.length}
              </span>

              <div style={{ width: "80px" }}>
                <select
                  value={selectedRecordsPerPage}
                  onChange={handleRecordsPerPage}
                  className="mx-2 form-select form-select-sm"
                >
                  {recordsPerPageOption.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Pagination centred on small screens, right-aligned ≥ 576 px */}
            <div className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0 w-100">
              <Pagination
                itemsPerPage={itemsPerPage}
                totalItems={totalItems}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyResource;
